export default Object.freeze({
  InitialEvaluation: 1,
  AditionalEvaluation: 2,
  EducationalService: 8,
  ServiceAssistant: 9,
});
